export default __webpack_public_path__ + "static/intro_bg-2c563d817db1d35c294e48ed5bcdaffb.webp";